import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";

import Progress from "../Progress";

const FormulaeTaskAction = ({
  items = [],
  onRequestParams,
  onComplete,

  //
  assistantStore,
  chatHelpersStore,
  component
}) => {

  const [progress, setProgress] = useState({label: "Adding formulae"})

  const handleComplete = async (...params) => {
    typeof onComplete === "function" && (await onComplete(...params));
  };

  const handleOnLoad = async () => {
    try {
      const formulaeBySheetId = {};

      const finalItems =
        (typeof onRequestParams === "function" && (await onRequestParams())) ||
        items;

      // group all formulae by target sheetId
      for (const formula of finalItems) {
        formulaeBySheetId[formula.sheetId] = formula;
      }

      const createdFormulae = [];

      for (const sheetId in formulaeBySheetId) {
        const { fields, parentSheetId, sheetName } = formulaeBySheetId[sheetId];

        // for subsheet, pass the parent sheetId, else sheetId
        const _sheetId = parentSheetId || sheetId;
        await assistantStore.fetchAndLoadSheetConfig(_sheetId);

        const listConfig = assistantStore.getListConfig(_sheetId);

        const fieldsPromises = fields.map((field) =>
          chatHelpersStore.generateFormulaColumnSchema(
            field,
            listConfig?.listData || [],
            _sheetId
          )
        );

        const formulaeFields = (await Promise.allSettled(fieldsPromises))
          .filter((item) => item.reason !== "rejected" && item.value)
          .map((item) => item.value);

        try {
          if (!formulaeFields.length) continue;

          await assistantStore.addColumnsToSheet({
            columns: formulaeFields.map((column) => {
              column.column_id = 0;
              column.options = JSON.stringify(column.options);
              return column;
            }),
            list_name: sheetName,
            list_id: sheetId,
            parent_id: parentSheetId,
          });

          createdFormulae.push({
            sheetId,
            parentSheetId,
            sheetName,
            fields: formulaeFields,
          });
        } catch (e) {
          continue;
        }
      }

      await handleComplete(createdFormulae);
    } catch (e) {
      console.log(`e->`, e);
    }
  };

  const renderFormulaeTaskAction = () => {
    return (
      <Progress progress={progress} parentComponent={component}/>
    );
  };

  useEffect(() => {
    handleOnLoad();
  }, []);

  return renderFormulaeTaskAction();
};

export default inject(({ store }) => {
  return {
    assistantStore: store.assistantStore,
    chatHelpersStore: store.chatHelpersStore,
  };
})(observer(FormulaeTaskAction));
